var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHideIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.86 15.8263C14.4614 16.8849 12.7584 17.4715 11 17.5C5.27273 17.5 2 11 2 11C3.01773 9.11655 4.42929 7.47101 6.14 6.17377M9.28182 4.69502C9.845 4.56411 10.4216 4.49867 11 4.50002C16.7273 4.50002 20 11 20 11C19.5033 11.9227 18.911 12.7914 18.2327 13.5919M12.7345 12.7225C12.5098 12.962 12.2388 13.1541 11.9378 13.2873C11.6367 13.4205 11.3116 13.4922 10.9821 13.4979C10.6525 13.5037 10.3251 13.4435 10.0195 13.3209C9.71387 13.1983 9.43623 13.0158 9.20315 12.7844C8.97007 12.5529 8.78632 12.2772 8.66287 11.9737C8.53942 11.6702 8.47879 11.3451 8.48461 11.0178C8.49042 10.6905 8.56256 10.3678 8.69672 10.0688C8.83087 9.76977 9.0243 9.50066 9.26545 9.27751",
    stroke: "#E0E0E0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2L20 20",
    stroke: "#E0E0E0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideIconDark);
export default __webpack_public_path__ + "static/media/hide-icon-dark.93beb1f8de87e5b53f90e8055ff103b5.svg";
export { ForwardRef as ReactComponent };